import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import Icon from '../atoms/Icon';
import Button from '../atoms/Button';
import styles from '../../styles/components/molecules/BillingAccountListed.module.scss';
import { toLocationStr } from '../../lib/utils';

interface BillingAccountProps {
  className?: string;
  float?: boolean;
  half?: boolean;
  third?: boolean;
  border?: boolean;
  data: any;
  onClick?: () => void;
}

export default function BillingAccount(props: BillingAccountProps) {
  const { t } = useTranslation(['common']);
  const { data, float, half, third, onClick, className } = props;
  const { status, type, name, tax_id, billing_address, images } = data as any;
  // const locationStr = toLocationStr(billing_address, true);
  const classes = clsx(
    styles.billingAccountListed,
    styles.small,
    { [styles.float]: float },
    { [styles.half]: half },
    className
  );

  return (
    <div className={classes}>
      <figure>
        <figcaption>
          <small>
            <b>{name}</b>
            {tax_id && (
              <>
                <br />
                {tax_id}
              </>
            )}
          </small>
          <ul>
            <li></li>
            <li></li>
            <li>
              <Button
                small
                dark
                icon="edit"
                label={t('common:cta-edit')}
                onClick={onClick}
              />
            </li>
          </ul>
        </figcaption>
        <div>
          <Icon name={'billing_account'} />
        </div>
      </figure>
    </div>
  );
}
